import { EditorCanvasComponent } from "./editor-canvas.component";

export abstract class FeatureBase {
    protected editorCanvasComponent: EditorCanvasComponent;

    constructor() {
    }

    activate(editorCanvasComponent) {
        this.editorCanvasComponent = editorCanvasComponent;
        this.initialize();
    }

    deactivate() {
        this.dispose();
    }

    initialize() {
        // To be implemented by each tool
    }

    dispose() {
        // To be implemented by each tool
    }

    getCurrentLayer(){
        return this.editorCanvasComponent.layers.find(x => x.key == this.editorCanvasComponent.editorService.currentLayer.value).value;
    }

    getRelativePointerPosition(node) { //from official konva site
        // the function will return pointer position relative to the passed node
        var transform = node.getAbsoluteTransform().copy();
        // to detect relative position we need to invert transform
        transform.invert();

        // get pointer (say mouse or touch) position
        var pos = node.getStage().getPointerPosition();

        // now we find relative point
        return transform.point(pos);
    }
}